import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import classNames from "classnames";
import { Grid, FormControl, OutlinedInput, Input, GridList } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typo from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import Button from '../../components/ButtonCustom';
import { LinkRouter, LinkCTA } from '../../components/Link';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, CheckBoxComponent, DatePickerComponent } from '../../components/FormElement';
import validators from '../../utils/validators';

import clsx from 'clsx';
import { domainName } from '../../../portal.config';
import { getAppCfg } from '../../utils/common';
const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";
const checkIcon = portalCfg.publicPath + "/icons/check.png";
const fb_icon = portalCfg.publicPath + "/icons/facebook_icon.png";
const go_icon = portalCfg.publicPath + "/icons/google_icon.png";

const styles = theme => ({
    container: {
        paddingTop: theme.spacing(30),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop4x: {
        marginTop: theme.spacing(8),
    },
    formLogin: {
        marginTop: theme.spacing(4),
        backgroundColor: theme.palette.background.box,//'#ffffff1f',
        borderRadius: 10,
        padding: theme.spacing(5, 5, 5, 5),
    },
});
function OtpView(props){
    const { classes, t, onLogin, countDown, onResend, obfuscatedValue } = props;
    return(
        <PublicPage rightComponent={<OtpViewComponent classes={classes} t={t} onSubmit={onLogin} countDown={countDown} onResend={onResend} obfuscatedValue={obfuscatedValue} />} />
    )
}
function OtpViewComponent(props) {
    const { classes, t, countDown, onResend, onSubmit, obfuscatedValue } = props;
    const config = getAppCfg();
    let isEmailOtp = config && config.auth_support && config.auth_support.email_otp;

    return (
        <Grid xs={12} item justify='center' container>

                <Grid xs={12} sm={12} item container justify='center'>
                    <Typo variant='h2' color={domainName =='buyway' ? 'onPrimary' : 'primary'}>{t('btn_login')}</Typo>
                </Grid>

                <Grid xs={12} sm={12} item container className={classes.marginTop4x} >
                    <Typo variant='h5' color={domainName =='buyway' ? 'onPrimary' : 'primary'}>{t('authenticate')}</Typo>
                </Grid>
                <Grid item container>
                    <Typo color={domainName =='buyway' ? 'onPrimary' : 'primary'} variant='body2'>{t('otp_title')}{obfuscatedValue}{isEmailOtp ? t('verify_introduction_2') : t('otp_title2')}</Typo>
                </Grid>
                <OtpForm classes={classes} t={t}
                    onSubmit={onSubmit}
                    onResend={onResend}
                    countDown={countDown}
                />

        </Grid>

    )

}


function OtpForm(props) {
    const { classes, t, onResend, countDown } = props;
    return (
        <Form
            onSubmit={props.onSubmit}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item className={classes.marginTop4x}>
                    <Field
                        name="otp_code"
                        component={TextFieldComponent}
                        placeholder={t('enter_your_otp')}
                        isEdit={true}
                        
                        validate={validators.composeValidators(validators.mustBeNumber)}
                    />
                    <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                        <LinkCTA color='primary'
                            onClick={onResend} id="btn_otp_resend_code">
                            {t('resend_code')}
                        </LinkCTA>
                    </Grid>

                    <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                        <Button color='primary' fullWidth onClick={handleSubmit} id="btn_otp_authen_signin">{t('authenticate_and_sign_in')}</Button>
                    </Grid>

                </Grid>
            )} />

    )
}
export default withStyles(styles)(withTranslation()(OtpView));